import { Image } from 'antd';
import { BuildingDetailsCard, TaggedCard, Card, Legend } from '../../../design-system';
import { useState, useEffect } from 'react';
import { getBuildingNameFromAddress } from '../../../global/api';
import './building-detail.css';
import { newPositiveAttributeFilter } from "@gooddata/sdk-model";

import EndUsePieChart from '../../../components/customInsights/EndUsePieChart';
import DecarbonizationRoadmap from '../../../components/customInsights/DecarbonizationRoadmap';
import RadioControlledInsight from "../../../components/molecules/RadioControlledInsight"

interface Props {
    building: any;
    extra?: JSX.Element
    show?: boolean;
    nameFromBQ?: boolean;
    customerData?: any;
    large?: boolean;
}


const createFilters = (buildingName: string) => {
    const buildingNameDisplayForm = "label.out_building_information.building_name"
    return [newPositiveAttributeFilter(buildingNameDisplayForm, [buildingName])];
}

const radioButtonOptions = [
    {label: "Carbon", value: "carbon"},
    {label: "Energy", value: "energy"},
    {label: "Cost", value: "cost"}
]

const BuildingDetail = ({building, show = true, extra, nameFromBQ = false, customerData, large = false}: Props) => {

    let selectedBuilding = building;
    const [BQName, setBQName] = useState<string>(null);
    const [filters, setFilters] = useState<any>([]);

    useEffect(() => {
        setBQName(null);
        setFilters([]);
        if (building !== undefined && building !== null) {
            if (nameFromBQ) {
                setBQName(building.name);
                setFilters(createFilters(building.name));
            } else {
                getBuildingNameFromAddress(
                    building.address,
                    (data) => {
                        if (data !== null) {
                            setBQName(data['a__building_name']);
                        }
                        setFilters(createFilters(data['a__building_name']));
                    },
                    () => null
                )
            }
        }
    }, [building, nameFromBQ])


    if (selectedBuilding === undefined || selectedBuilding === null) {
        show = false;
        selectedBuilding = {};
    }

    const showDataCollectors = false;

    const buildingType = selectedBuilding.facility_type || selectedBuilding.type;

    const roundedSquareFeetFromSquareMeters = (squareMeters: number) => {
        const squareFeetFromSquareMeters = 10.7639;
        return Math.round(squareMeters * squareFeetFromSquareMeters)
    }

    return (
        <div className={show ? (large ? "drawer-show-large" : "drawer-show") : "drawer-hide"}>
            <div className={(large ? "drawer-content-large" : "drawer-content")}>

                {extra && <div className="flex-row">{extra}</div>}

                {building && building.address &&
                 <Image
                     src={ "https://maps.googleapis.com/maps/api/streetview?fov=120&size=500x300&key=AIzaSyAHjrNBzQbo3Lp2jsdgQ8e9u3GLRHhTvvo&location=" + encodeURIComponent(building['address'])}
                 />}



        <BuildingDetailsCard
            building={selectedBuilding.name}
            customer={selectedBuilding.customer}
            areaInSquareMeters={selectedBuilding.gfa_m2 ? parseFloat(selectedBuilding.gfa_m2).toLocaleString() : undefined}
            areaInSquareFeet={selectedBuilding.gfa_m2 ? roundedSquareFeetFromSquareMeters(selectedBuilding.gfa_m2).toLocaleString() : undefined}
            yearBuilt={selectedBuilding.year_built}
            address={selectedBuilding.address}
            buildingType={buildingType ? [buildingType] : null}
            carbonMandate={selectedBuilding.carbon_mandate}/>

        {showDataCollectors &&
            <TaggedCard
                label="Data Collectors"
                tags={ [] }
                colors={ ["black"] }
                backgroundColors={ ["#88FF00"] }
                lastTag="+ Add Data Collector"
            />
        }

        {building && building.id &&
         <Card
             title="Identified Features"
         child={
             <>
                 <Image
                 src={ "https://storage.googleapis.com/audette-rtu-images-for-website/rooftop-" + building.id + ".jpg" }
                 fallback="data:image/png;base64,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"
                 />

                 <Legend
                     items={[ "Roof Top Unit", "Air Handling Unit", "Cooling Tower" ]}
                     colours={[ "var(--audette-hot-pink)", "var(--audette-light-teal-secondary)", "var(--audette-purple)" ]}
                 />
                 </>} /> }



        {BQName !== null && customerData !== undefined &&
            <Card
         title="End Use Breakdown"
         child={
             <RadioControlledInsight
             options={radioButtonOptions}
             inDrawer={true}
             render={(option) =>
                         <EndUsePieChart
                             workspace={customerData.workspace_uid}
                             type={option}
                             filters={filters}/>
                         } />
         } />
            }

            {BQName !== null && customerData !!== undefined &&
             <Card
                 title="Decarbonization Roadmap"
                 child={
                     <div className="drawer-insight">
                         <DecarbonizationRoadmap
                             workspace={customerData.workspace_uid}
                             type="emissions"
                     filters={createFilters(BQName)}
                     micro={true}/>
                     </div>
                 } />
            }
        </div>
        </div>
    );

}

export default BuildingDetail;
